import { showHide } from "./showHide";

/**
 * 显示元素
 * @param el HTMLElement
 */
export const showElement = (els: string | HTMLElement | NodeListOf<HTMLElement> | HTMLElement[] | null | undefined) => {
  if (!els) {
    return
  }
  showHide(els, true)
}

